
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.feature-spotlight {
  display: grid;
  grid-template-columns: repeat(14, 1fr);

  &__lead {
    grid-column: 2 / span 12;
    grid-row: 1;
    text-align: center;
    display: grid;
  }

  &__eyebrow {
    display: block;
    margin-bottom: 1.25rem;
  }

  &__heading {
    word-break: break-word;
    margin: 0;
  }

  &__heading + &__subheading {
    margin: 1.25rem 0 0;
  }

  &__subheading {
    ul {
      text-align: left;
    }
  }

  &__icon-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 1.25rem;
  }

  &__icon {
    width: $icon-width;
    margin: 0;
  }

  &__icon + &__icon-text {
    margin-top: 1.875rem;
  }

  &__children {
    grid-row: 3;
    grid-column: 2 / span 12;
    text-align: center;
    margin-top: 2.5rem;

    &--zippered {
      grid-row: 3;
    }
  }

  &__cta {
    display: block;

    // Adds spacing between .feature-spotlight__cta and .feature-spotlight__testimonial
    & + div {
      margin-top: 2rem;
    }
  }

  &__media {
    grid-column: 2 / span 12;
    grid-row: 2;
    margin-top: 2.5rem;
    border-radius: 25px;
    text-align: center;
    overflow: hidden;

    picture img,
    img,
    .image-placeholder {
      width: 100%;
    }
  }
  &__lead + &__children {
    margin-top: 2rem;
  }

  @include media-query(tablet) {
    grid-template-columns: [left-gutter] 1fr [content] 12fr [right-gutter] 1fr;

    &__icon-wrapper {
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: unset;
      align-items: center;
      margin-bottom: 1.875rem;
    }

    &__icon {
      position: relative;
      margin-right: 1.25rem;
    }

    &__icon + &__icon-text {
      margin-top: 0;
    }

    &__heading + &__subheading {
      margin: 1.5rem 0 0;
    }

    &__lead {
      grid-column: 1 / span 5;
      grid-row: 1;
      align-self: center;
      text-align: left;
      display: block;

      &--flipped {
        grid-column: 8 / span 5;
      }
    }

    &__lead + &__children {
      margin-top: 2.5rem;
    }

    &__children {
      grid-row: 2;
      grid-column: 1 / span 5;
      text-align: left;

      &--flipped {
        grid-column: 8 / span 5;
      }
    }

    &__children + &__media {
      margin-bottom: 0;
    }

    &__media {
      display: grid;
      grid-row: 1;
      grid-column: 7 / span 6;
      align-items: center;
      margin-top: 0;

      &--flipped {
        grid-column: 1 / span 6;
      }

      img {
        margin-top: 0;
      }
    }

    &__cta {
      display: inline-block;

      // Adds spacing between .feature-spotlight__cta and .feature-spotlight__testimonial
      & + div {
        margin-top: 2.5rem;
      }
    }

    &--has-children {
      .feature-spotlight__lead {
        align-self: end;
      }

      .feature-spotlight__children {
        align-self: start;
      }

      .feature-spotlight__media {
        grid-row: 1/3;
      }
    }
  }

  @include media-query(desktop) {
    &__cta {
      display: inline-block;

      // Adds spacing between .feature-spotlight__cta and .feature-spotlight__testimonial
      & + div.feature-spotlight__demo-cta {
        margin-left: 1.875rem;
      }
    }
  }
}
`